import { useEffect, useState } from "react";
import PageShell from "../components/layout/PageShell";
import { getVariantStats, promoteWinner, regenerateChallenger } from "../services/crmService";
import toast from "react-hot-toast";

export default function VariantsPage() {
    const [items, setItems] = useState([]);
    const [loadingProjectId, setLoadingProjectId] = useState("");

    const loadData = async () => {
        try {
            const res = await getVariantStats();
            setItems(res || []);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const handlePromote = async (projectId, variantKey) => {
        try {
            setLoadingProjectId(projectId);
            await promoteWinner(projectId, variantKey);
            toast.success(`Variant ${variantKey} promoted`);
            await loadData();
        } catch (error) {
            console.error(error);
            toast.error("Failed to promote variant");
        } finally {
            setLoadingProjectId("");
        }
    };

    const handleRegenerate = async (projectId) => {
        try {
            setLoadingProjectId(projectId);
            await regenerateChallenger(projectId);
            toast.success("Challenger regenerated");
            await loadData();
        } catch (error) {
            console.error(error);
            toast.error("Failed to regenerate challenger");
        } finally {
            setLoadingProjectId("");
        }
    };

    return (
        <PageShell title="Variants">
            <div className="crm-page-body">
                {items.map((item) => {
                    const performance = item.performance || [];
                    const a = performance.find((x) => x.variantKey === "A") || {};
                    const b = performance.find((x) => x.variantKey === "B") || {};

                    return (
                        <div className="crm-card" key={item.projectId}>
                            <div className="variant-header">
                                <div>
                                    <h3>{item.businessName}</h3>
                                    <p>
                                        Active Variant: <strong>{item.activeVariant}</strong>
                                        {" | "}
                                        Winner: <strong>{item.winningVariantKey || "-"}</strong>
                                    </p>
                                </div>

                                <div className="variant-actions">
                                    <button
                                        className="crm-btn"
                                        onClick={() => handlePromote(item.projectId, "A")}
                                        disabled={loadingProjectId === item.projectId}
                                    >
                                        Promote A
                                    </button>

                                    <button
                                        className="crm-btn"
                                        onClick={() => handlePromote(item.projectId, "B")}
                                        disabled={loadingProjectId === item.projectId}
                                    >
                                        Promote B
                                    </button>

                                    <button
                                        className="crm-btn crm-btn-primary"
                                        onClick={() => handleRegenerate(item.projectId)}
                                        disabled={loadingProjectId === item.projectId}
                                    >
                                        Regenerate Challenger
                                    </button>
                                </div>
                            </div>

                            <div className="crm-grid">
                                <div className="crm-card">
                                    <h4>Variant A</h4>
                                    <p>Views: {a.views || 0}</p>
                                    <p>Primary Clicks: {a.primaryClicks || 0}</p>
                                    <p>Secondary Clicks: {a.secondaryClicks || 0}</p>
                                    <p>Leads: {a.leads || 0}</p>
                                </div>

                                <div className="crm-card">
                                    <h4>Variant B</h4>
                                    <p>Views: {b.views || 0}</p>
                                    <p>Primary Clicks: {b.primaryClicks || 0}</p>
                                    <p>Secondary Clicks: {b.secondaryClicks || 0}</p>
                                    <p>Leads: {b.leads || 0}</p>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </PageShell>
    );
}